export const GET_SALES_PERSON = 'GET_SALES_PERSON';
export const SALES_PERSON_REQUEST = 'SALES_PERSON_REQUEST';
export const CREATE_SALES_PERSON = 'CREATE_SALES_PERSON';
export const UPDATE_SALES_PERSON = 'UPDATE_SALES_PERSON';
export const DELETE_SALES_PERSON = 'DELETE_SALES_PERSON';
export const SALES_PERSON_REQUEST_FAILURE = 'SALES_PERSON_REQUEST_FAILURE';
export const GET_SALES_PERSON_PAGE = 'GET_SALES_PERSON_PAGE';
export const SALES_PERSON_REQUEST_SUCCESS = 'SALES_PERSON_REQUEST_SUCCESS';